<style>
.virtualRecipientsTable .table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.virtualRecipientsTable .table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.virtualRecipientsTable .table__container--panel p {
  font-size: 12px;
}
.virtualRecipientsTable .table__container--filter {
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
  font-size: 12px;
}
</style>

<template>
  <v-layout
    row
    fill-height
    wrap
    class="virtualRecipientsTable"
  >
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout
      class="table__container--panel"
      wrap
    >
      <v-icon
        style="padding-left: 10px"
        title="Pobierz"
        @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
      >description</v-icon>
      <v-icon
        @click="addProjectedReceiver"
        title="Nowy projektowany odbiorca"
      >add</v-icon>
      <v-icon
        @click="$emit('removeFilters')"
        title="Usuń filtry"
      >cancel</v-icon>
      <v-icon
        @click="$emit('deselectRows')"
        title="Odznacz wszystkie"
      >select_all</v-icon>
      <v-layout
        align-right
        justify-end
      >
        <div style="margin-top: auto; margin-bottom: auto;">
          <p style="line-height:29px">Liczba wyników: {{numberFiltered}}/{{numberAll}}</p>
        </div>
        <input
          type="text"
          class="table__container--filter"
          v-model="filter"
          placeholder="Treść filtra"
        >
      </v-layout>
      <div class="table__container--separator"></div>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    tableTitle: "virtualRecipientsTable",
    filter: "",
    virtualRecipientsFiltered: undefined,
    numberAll: 0,
    numberFiltered: 0
  }),
  components: {
    AgGridVue,
    ExportTableData,
    Buttons: {
      template:
        '<span><v-icon small title="Przybliż do obiektu" @click="zoomToFeature">fas fa-search-plus</v-icon><v-icon small title="Edytuj projektowanego odbiorcę" @click="editFeature">edit</v-icon><v-icon small title="Usuń projektowanego odbiorcę" @click="removeVirtualReicipient">delete</v-icon> </span>',
      computed: {
        activeModals() {
          return this.$store.getters.getModalsList;
        }
      },
      methods: {
        show(title) {
          if(this.activeModals.indexOf(title) == -1) {
            this.$store.commit("addModal", title);
            this.$modal.show(title);
          }
        },
        removeVirtualReicipient() {
          let id = this.params.data.id;
          const self = this;
          this.$emit("confDialogOpened", true);
          self.$modal.show("dialog", {
            title: "Usuwanie projektowanego odbiorcy",
            text: "Czy na pewno chcesz usunąć projektowanego odbiorcę?",
            buttons: [
              {
                title: "NIE",
                handler: () => {
                  this.$emit("confDialogOpened", false);
                  self.$modal.hide("dialog");
                  return;
                }
              },
              {
                title: "TAK",
                default: true,
                handler: () => {
                  self.$store
                    .dispatch("deleteVirtualRecipient", id)
                    .then(success => {
                      if(success) {
                        self.$root.$emit("removeVirtualRecipientPoint", id);
                        self.$root.$emit(
                          "showSnackbar",
                          "success",
                          "Pomyślnie usunięto projektowanego odbiorcę"
                        );
                        let selectedData = this.params.api.getSelectedRows();
                        this.params.api.updateRowData({remove: selectedData});
                      } else {
                        self.$root.$emit(
                          "showSnackbar",
                          "red",
                          "Podczas usuwania projektowanego odbiorcy wystąpił błąd"
                        );
                      }
                    });
                  this.$emit("confDialogOpened", false);
                  self.$modal.hide("dialog");
                }
              }
            ]
          });
        },
        editFeature() {
          this.$root.$emit("editProjectedReceiver", this.params.data);
          this.show("addProjectedReceiverModal");
        },
        zoomToFeature() {
          this.$root.$emit("zoomToFeature", this.params.data, {
            srid: "EPSG:2180"
          });
        }
      }
    }
  },
  computed: {
    virtualRecipients() {
      return this.$store.getters.getVirtualRecipients;
    },
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filteredNumber,
        rowSelection: "multiple",
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "",
        cellRendererFramework: "Buttons",
        minWidth: 65,
        width: 65
      },
      {headerName: "ID", field: "id", sort: "asc"},
      {headerName: "Adres", field: "properties.address"},
      {
        headerName: "Opis powiązanego profilu rozbioru",
        field: "properties.curve_description"
      },
      {
        headerName: "ID powiązanego profilu rozbioru",
        field: "properties.curve_id"
      },
      {headerName: "Przewidywany rozbiór", field: "properties.demand"},
      {headerName: "Opis", field: "properties.description"},
      {headerName: "Węzeł nadrzędny", field: "properties.parent_junction"},
      {headerName: "Wzorzec rozbioru", field: "properties.pattern"},
      {headerName: "Jednostka", field: "properties.unit"}
    ];
  },
  methods: {
    addProjectedReceiver() {
      this.show("addProjectedReceiverModal");
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    loadData() {
      this.$store.dispatch("getVirtualRecipients").then(success => {
        if(success) {
          this.numberAll = this.virtualRecipients.features.length;
          this.numberFiltered = this.numberAll;
          this.gridOptions.api.setRowData(this.virtualRecipients.features);
        }
      });
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    editInspection() {
      if(this.gridOptions && this.gridOptions.api) {
        let selectedHydrants = this.gridOptions.api
          .getSelectedRows()
          .map(element => {
            return element.id;
          });
        this.$store.commit("setSelectedHydrantsEdited", selectedHydrants);
        this.$modal.hide("HydrantsRegisterInspection");
      }
    },
    setSelecetedRows() {
      if(this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.deselectAll();
        if(this.$store.getters.getInspectionTask) {
          this.gridOptions.api.forEachNode(rowNode => {
            this.$store.getters.getSelectedHydrantsEdited.forEach(hydrant => {
              if(hydrant === rowNode.data.id) {
                rowNode.setSelected(true);
              }
            });
          });
        } else if(this.$store.getters.getSelectedHydrants) {
          this.gridOptions.api.forEachNode(rowNode => {
            this.$store.getters.getSelectedHydrants.forEach(hydrant => {
              if(hydrant === rowNode.data.id) {
                rowNode.setSelected(true);
              }
            });
          });
        }
      }
    },
    deselectRows() {
      this.gridOptions.api.deselectAll();
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    removeFilters() {
      this.gridOptions.api.setFilterModel(null);
      this.filteredNumber();
      this.filter = "";
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  mounted() {
    this.$root.$on("refreshProjectedRecipients", this.loadData);
    this.$on("removeFilters", this.removeFilters);
    this.$on("deselectRows", this.deselectRows);
    this.$root.$on("setSelectedRows", this.setSelecetedRows);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/VirtualRecipientsTable.vue